import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ShoppingBag, Lock, Mail } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { authAPI } from '../../lib/api';
import { toast } from 'sonner';
import { getErrorMessage } from '../../utils/errorHandler';

const AdminLogin = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await authAPI.login(formData.email, formData.password);
      localStorage.setItem('admin_token', response.data.token);
      toast.success('Login successful!');
      navigate('/admin');
    } catch (error) {
      toast.error(getErrorMessage(error) || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-slate-100 flex items-center justify-center p-4" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="flex items-center justify-center gap-2 mb-4">
            <ShoppingBag className="w-10 h-10 text-[#8acb95]" />
            <span className="text-2xl font-semibold" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Gulf Star
            </span>
          </div>
          <h1 className="text-3xl font-medium tracking-tight mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>
            Admin Login
          </h1>
          <p className="text-slate-600">Sign in to manage your store</p>
        </div>

        <div className="bg-white rounded-2xl p-8 shadow-lg border border-slate-200">
          <form onSubmit={handleSubmit} data-testid="admin-login-form">
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium mb-2">Email</label>
                <div className="relative">
                  <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" />
                  <Input
                    type="email"
                    required
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    placeholder="[EMAIL_ADDRESS]"
                    data-testid="admin-email-input"
                    className="pl-10 rounded-lg"
                  />
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium mb-2">Password</label>
                <div className="relative">
                  <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" />
                  <Input
                    type="password"
                    required
                    value={formData.password}
                    onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                    placeholder="••••••••"
                    data-testid="admin-password-input"
                    className="pl-10 rounded-lg"
                  />
                </div>
              </div>
              <Button
                type="submit"
                disabled={loading}
                data-testid="admin-login-button"
                className="w-full bg-[#8acb95] text-white hover:bg-[#7bb885] rounded-full py-6 mt-6"
              >
                {loading ? 'Signing in...' : 'Sign In'}
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
